// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KGSSEagx9A7oUftcCfQh{border:1px #000;display:flex;margin:16px auto;position:relative}.yM7oagy20SGZpsYoIDFA:hover{text-decoration:none}.HuKUTmrch3_6ZynVmH6M{align-content:center;background-color:rgba(0,0,0,.4);bottom:0;color:#fff;display:flex;flex-wrap:wrap;position:absolute;width:100%}.HR2Kd0kQp59X7HOrzYoz{height:100px}.MJahvlfg2pUpEOQKPNEV{height:50px}.M_ol7ZVBhWc31_ra4CCK{height:auto;object-fit:none;width:100%}.awnxYNuHCekEPL3lA8X4{display:flex;justify-content:center;overflow:hidden;width:100%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contentWrapper": `KGSSEagx9A7oUftcCfQh`,
	"clockLink": `yM7oagy20SGZpsYoIDFA`,
	"clockOverlay": `HuKUTmrch3_6ZynVmH6M`,
	"clockOverlayDesktop": `HR2Kd0kQp59X7HOrzYoz`,
	"clockOverlayMobile": `MJahvlfg2pUpEOQKPNEV`,
	"image": `M_ol7ZVBhWc31_ra4CCK`,
	"widgetWrapper": `awnxYNuHCekEPL3lA8X4`
};
export default ___CSS_LOADER_EXPORT___;
